import { Component } from '@angular/core';
import { select } from '@angular-redux/store';
import { Observable } from 'rxjs/Observable';
import { Lab } from '../../../contracts/lab/lab.model';
import { ConfigService } from '../../config/config.service';

@Component({
  selector: 'mc-configuration',
  templateUrl: './configuration.component.html'
})
export class ConfigurationComponent {
  @select(['labState', 'currentLab']) currentLab$: Observable<Lab>;

  constructor(public config: ConfigService) { }

  get urtAgentDownloadUrl() {
    return this.config.appConfig.urtAgentDownloadUrl;
  }

  get userGuideDownloadUrl() {
    return this.config.appConfig.userGuideDownloadUrl;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/template/configuration/configuration.component.ts